/* =============================================
   HermanRX About Us — JavaScript
   ============================================= */
(function () {
    'use strict';

    /* ── Nav scroll ── */
    const nav = document.getElementById('ab-nav');
    if (nav) {
        window.addEventListener('scroll', () => {
            nav.classList.toggle('scrolled', window.scrollY > 50);
        }, { passive: true });
    }

    /* ── Mobile menu ── */
    const toggle = document.querySelector('.ab-nav-toggle');
    const mobileNav = document.getElementById('ab-nav-mobile');
    const closeBtn = document.querySelector('.ab-nav-mobile-close');

    if (toggle && mobileNav) {
        toggle.addEventListener('click', () => mobileNav.classList.add('active'));
        if (closeBtn) closeBtn.addEventListener('click', () => mobileNav.classList.remove('active'));

        mobileNav.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => mobileNav.classList.remove('active'));
        });
    }

    /* ── Smooth scroll ── */
    document.querySelectorAll('.ab-root a[href^="#"]').forEach(link => {
        link.addEventListener('click', function (e) {
            const id = this.getAttribute('href');
            if (id === '#') return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });

    /* ── Scroll reveal ── */
    const reveals = document.querySelectorAll('.ab-fadeup, .ab-reveal');
    if (reveals.length) {
        const io = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('ab-visible');
                    io.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

        reveals.forEach(el => io.observe(el));
    }

    /* ── Counter animation ── */
    const counters = document.querySelectorAll('[data-ab-count]');
    if (counters.length) {
        const counterIO = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const target = parseInt(el.getAttribute('data-ab-count'), 10);
                    let current = 0;
                    const duration = 1500;
                    const step = Math.ceil(target / (duration / 16));
                    const timer = setInterval(() => {
                        current += step;
                        if (current >= target) {
                            current = target;
                            clearInterval(timer);
                        }
                        el.textContent = current.toLocaleString();
                    }, 16);
                    counterIO.unobserve(el);
                }
            });
        }, { threshold: 0.5 });

        counters.forEach(el => counterIO.observe(el));
    }

})();
